import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const slides = [
  {
    id: 1,
    title: (
      <>
        The Best Solutions For <br /> Your Digital Success
      </>
    ),
    description: (
      <>
        Paval Soft delivers expert web, mobile, and digital <br />
        solutions for your business growth.
      </>
    ),
    link: "https://www.pavalsoftware.com/",
    linkText: "Explore Paval soft",

    image: "assets/img/pavalsoft/slide1.png",
  },
  {
    id: 2,
    title: (
      <>
        Powering Your <br />
        Online Growth
      </>
    ),
    description: (
      <>
        Paval soft crafts innovative web and mobile solutions, driving <br />
        digital success for businesses of all sizes
      </>
    ),

    link: "https://www.pavalsoftware.com/",
    linkText: "Reach New Heights",

    image: "assets/img/pavalsoft/slide2.png",
  },
  {
    id: 3,
    title: (
      <>
        Digital Innovation For <br />
        Your Business
      </>
    ),
    description: (
      <>
        Paval Soft delivers innovative digital solutions to help <br />
        your business into the future.
      </>
    ),

    link: "https://www.pavalsoftware.com/",
    linkText: "Connect with Our Team",
    image: "assets/img/pavalsoft/slide3.png",
  },
];

export default function AnimatedSlider() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="slider-container">
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        spaceBetween={30}
        effect="fade"
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        className="product-slider"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <div className="slide-content p-4">
              <AnimatePresence>
                {index === activeIndex && (
                  <div className="slidewrap d-flex container">
                    {/* Displaying the product image */}
                    <div className="displayimg ps-4 col-md-6">
                      <motion.img
                        key={slide.image} // Ensure this points to the correct product image URL
                        src={slide.image} // Make sure the image path is correct
                        alt={slide.title}
                        className="slide-image"
                        initial={{ opacity: 0, scale: 1.05 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1 }}
                      />
                    </div>
                    {/* Text overlay with title and description */}
                    <div className="text-overlay pe-4 col-md-6">
                      <motion.h2
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8 }}
                      >
                        {slide.title}
                      </motion.h2>

                      <motion.p
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                      >
                        {slide.description}
                      </motion.p>
                      <motion.a
                        href={slide.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="slide-button"
                        initial={{ y: 30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8, delay: 0.4 }}
                      >
                        {slide.linkText}
                      </motion.a>
                    </div>
                  </div>
                )}
              </AnimatePresence>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="swiper-button-prev">‹</div>
      <div className="swiper-button-next">›</div>
    </div>
  );
}
